<template>
  <div class="wrapper__content">
    <header :class="ThemeGet" class="header">

      <div class="header__logo d-f align-center">
        <LogoIcon class="logo-image mr-1"></LogoIcon>
        <router-link class="h2 active" to="/">Zinderland</router-link>
      </div>

      <div class="header__nav-list d-f align-center">

        <ul class="header__nav d-f align-center mr-2">
          <li class="header__nav-item">
            <router-link :class="ThemeGet" :to="$root.Configs.HomeURL" class="t-d light-text"
                         exact-active-class="active">
              Главная
            </router-link>
          </li>
          <li class="header__nav-item">
            <router-link :class="ThemeGet" class="t-d light-text" exact-active-class="active" to="/news">Новости
            </router-link>
          </li>
          <li class="header__nav-item">
            <router-link :class="ThemeGet" class="t-d light-text" exact-active-class="active" to="/wiki">Вики
            </router-link>
          </li>
          <li class="header__nav-item">
            <router-link :class="ThemeGet" class="t-d light-text" exact-active-class="active" to="/forum">Форум
            </router-link>
          </li>
          <li class="header__nav-item">
            <router-link :class="ThemeGet" class="t-d light-text" exact-active-class="active" to="/game">Играть
            </router-link>
          </li>
        </ul>
        <ul class="header__profile d-f align-center">

          <li class="header__profile-item mr-1 small-trans">
            <div class="not-count"></div>
            <router-link to="/im">
              <i :class="ThemeGet" class="far fa-envelope ui-icon light-text"></i>
            </router-link>
          </li>

          <li class="header__profile-item mr-2 small-trans">
            <div class="not-count"></div>
            <i :class="ThemeGet" @click="isOpen = !isOpen" class="far fa-bell ui-icon light-text"></i>
            <div :class="{ 'active': isOpen, 'dark': ThemeGet === 'dark', 'light': ThemeGet === 'light' }"
                 class="notification-tab dropdown-window">
              <span>123</span>
            </div>
          </li>

          <li class="header__profile-item mr-2">
            <span :class="ThemeGet" class="mr-05 light-text small-trans">
              Выход</span>
            <i :class="ThemeGet" class="fas fa-sign-out-alt ui-icon small-trans light-text"></i>
          </li>

          <li class="header__profile-item">
          <span @click="ThemeSelection(ThemeGet, ThemeGet === 'light' ? 'dark' : 'light')" v-if="ThemeGet === 'light'">
            <i class="fas fa-moon moon ui-icon"></i>
          </span>
          </li>
          <li class="header__profile-item">
          <span @click="ThemeSelection(ThemeGet, ThemeGet === 'light' ? 'dark' : 'light')" v-if="ThemeGet === 'dark'">
            <i class="fas fa-sun sun ui-icon"></i>
          </span>
          </li>
        </ul>

      </div>

    </header>

    <div class="content__wrapper d-f" style="">
      <div class="sidebar br-10">
        <div class="sidebar__fix">
          <div class="sidebar__profile d-f align-center mb-2">
            <img alt="nickname" class="sidebar__user-avatar avatar-br-5 mr-1" src="../../Assets/Image/unnamed.jpg">
            <div class="d-f flex-column">
              <router-link :class="ThemeGet" class="mb-1 sidebar__profile-nickname light-text" to="/user/1">
                { UserName }
              </router-link>
              <router-link :class="ThemeGet" class="sidebar__profile-nickname small" to="/user/1/settings">
                Редактировать
              </router-link>
            </div>
          </div>
          <div class="sidebar__profile-count-info d-f flex-column">
            <div class="mb-1 d-f justify-between">
              <span :class="ThemeGet" class="light-text">Статистика</span>
              <router-link :class="ThemeGet" class="small" to="/user/1/stats">
                Подробнее..
              </router-link>
            </div>
            <div class="d-f justify-center">
              <div class="sidebar__count-info d-f flex-column mr-1 mb-1">
                <span class="small-trans gray mb-05">Сыграно игр</span>
                <span :class="ThemeGet" class="h2 light-text">0</span>
              </div>
              <div class="sidebar__count-info d-f flex-column">
                <span class="small-trans gray mb-05">Чего-то ещё</span>
                <span :class="ThemeGet" class="h2 light-text">0</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="ThemeGet" class="content br-10">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import LogoIcon from "../../Components/Icons/LogoIcon";

  export default {
    name: "MainLayout",
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      ThemeGet: function () {
        return this.$store.getters.ThemeGet;
      },
    },
    components: {
      LogoIcon
    },
    mounted() {
      this.ThemeCheck();

      this.isOpen = false
    },
    methods: {
      ThemeSelection: function (currentTheme, chosenTheme) {
        let search_all = document.querySelectorAll("[class*='" + currentTheme + "']");

        if (search_all.length > 0) {
          let i = 0;
          for (i = 0; i < search_all.length; i++) {
            search_all[i].classList.remove(currentTheme);
            search_all[i].classList.add(chosenTheme);
          }
          this.$store.dispatch('SetThemeAct', chosenTheme);
          this.ThemeCheck();
        }
      },
      ThemeCheck: function () {
        if (this.ThemeGet === 'light') {
          let search_all = document.querySelectorAll("[class*='dark']");
          let i = 0;
          for (i = 0; i < search_all.length; i++) {
            search_all[i].classList.remove("dark");
            search_all[i].classList.add("light");
          }
        }
        if (this.ThemeGet === 'dark') {
          let search_all = document.querySelectorAll("[class*='light']");
          let i = 0;
          for (i = 0; i < search_all.length; i++) {
            search_all[i].classList.remove("light");
            search_all[i].classList.add("dark");
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
